import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * A small tag for highlighting new features.
 * Shows "NEW" text in a compact badge.
 */
const NewBadge = ({ className, label = 'NEW' }) => {
  return <span className={classNames('new-badge', className)}>{label}</span>;
};

NewBadge.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};

export default NewBadge;
